import Web3 from 'web3'
import bmAbi from './bmAbi.json'
import minterAbi from './minterAbi.json'
import metadataAbi from "./metadataAbi.json"
import mutatorAbi from './mutatorAbi.json'
import brainzAbi from "./brainzAbi.json"

const ethereum = window.ethereum
const web3 = new Web3(ethereum)
const bmContract = new web3.eth.Contract(bmAbi, '0xbD091F143eE754f1d755494441aee781d918Cb93')
const minterContract = new web3.eth.Contract(minterAbi, '0xEAC28C1764EAb74DC566375265d313a0f619CEBc')
const metadataContract = new web3.eth.Contract(metadataAbi, '0x692A98d0780B2502e5875428814Fe3358a7e4629')
const mutatorContract = new web3.eth.Contract(mutatorAbi, '0x711B6E50d0BD28dAF556e77Bee7EE5cdF24594D2')
const brainzContract = new web3.eth.Contract(brainzAbi, '0x2Ca1803b5eB52c2AFf90cb2801DDA3CcAD49F64c')


const mintAmountMap = {
  1: '60000000000000000',
  2: "120000000000000000",
  3: "180000000000000000",
  4: "240000000000000000",
  5: '300000000000000000',
  6: '360000000000000000',
  7: '420000000000000000',
  8: '480000000000000000',
  9: '540000000000000000',
  10: '600000000000000000'
}

export const isMetaMaskInstalled = () => {
  return Boolean(ethereum && ethereum.isMetaMask)
}

export const currentConnectedAddress = () => {
  return ethereum.request({ method: 'eth_accounts' })
}

export const requestAccounts = () => {
  return ethereum.request({ method: 'eth_requestAccounts' })
}

export const givawayMint = (address) => {
  minterContract.methods.giveawayMint(address).send({ from: address })
}

export const mintToken = async (amount, address) => {
  return minterContract.methods.mint(amount).send({ from: address, value: mintAmountMap[amount] })
}

export const getSupply = async () => {
  try {
    return await bmContract.methods.totalSupply().call()
  }
  catch (e) {
    console.error("failed to get supply")
    console.error(e)
  }
}

export const getMintingState = async () => {
  return parseInt(await minterContract.methods.mintingState().call(), 10)
}

export const getWhitelistedMints = async address => {
  try {
    return parseInt(await minterContract.methods.whitelist(address).call(), 10)
  }
  catch (e) {
    return 0
  }
}

export const supplyEvent = (getTotalSupply) => {
  return bmContract.events.Transfer({filter: {from: '0x0000000000000000000000000000000000000000'}}, (error, event) => getTotalSupply())
}

export const balanceOf = async (address) => {
  try {
    return parseInt(await bmContract.methods.balanceOf(address).call(), 10)
  }
  catch (e) {
    return 0
  }
}

export const tokenOfOwner = async (address, bal) => {
  const bmIds = []
  for(let i = 0; i < bal; i++){
    try {
      const bmi = parseInt(await bmContract.methods.tokenOfOwnerByIndex(address, i).call(), 10)
      const bm = await bmContract.methods.tokenIdToBitMonster(bmi).call()
      const name = await metadataContract.methods.getName(bmi).call()
      bmIds.push({
        tokenId: bmi,
        bitMonster: bm,
        name: name
      });
    }
    catch (e) {
      console.error(e)
      return bmIds;
    }
  }
  return bmIds
}

export const rerollTrait = async (id, trait, address) => {
  try {
    await mutatorContract.methods.rerollTrait(id, trait).send({ from: address })
  }
  catch (e) {
    console.error(e)
  }
}

export const brainzBalance = async address => {
  try {
    let s = await brainzContract.methods.balanceOf(address).call();
    if (s.length >= 18) {
      s = s.substring(0, s.length - 18);
    }
    return parseInt(s, 10);
  }
  catch (e) {
    console.error(e)
    return 0
  }
}

export const rerollAll = async (id, address) => {
  try {
    await mutatorContract.methods.rerollAll(id).send({from: address});
  }
  catch (e) {
    console.error(e)
  }
}

export const mutate = async (idDonor, idRecipient, trait, count, address) => {
  try {
    await mutatorContract.methods.mutate(idDonor, idRecipient, trait, count).send({from: address});
  }
  catch (e) {
    console.error(e)
  }
}

export const stake = async (amount, address) => {
  try {
    await brainzContract.methods.stake(amount).send({from: address});
  } catch (e) {
    console.log(e)
  }
}


export const getPendingBrainz = async address => {
  try {
    const bal = await balanceOf(address)
    const bms = (await tokenOfOwner(address, bal)).map(x => x.tokenId);
    let total = 0;

    for (let i = 0; i < bal; ++i) {
      let s = (await brainzContract.methods.calculateRewards(bms[i]).call());
      if (s.length > 18) {
        s = s.substring(0, s.length - 18);
      }
      total += parseInt(s, 10);
    }

    return total;
  }
  catch (e) {
    console.error(e)
  }
}

export const claimBrainz = async address => {
  try {
    await brainzContract.methods.claimBrainz().send({from: address})
  }
  catch (e) {
    console.error(e)
  }
}
